import { render, staticRenderFns } from "./UrlTable.vue?vue&type=template&id=721559a5&"
import script from "./UrlTable.vue?vue&type=script&lang=js&"
export * from "./UrlTable.vue?vue&type=script&lang=js&"
import style0 from "./UrlTable.vue?vue&type=style&index=0&id=721559a5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports